import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaShieldAlt,
  FaTachometerAlt,
  FaShoppingCart,
  FaLock,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const SecureAndFastEcommerceWebsitesInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Secure & Fast E-commerce Websites in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Trust and Speed</Subheading>}
        heading={
          <Heading>
            Secure & <span tw="text-primary-500">Fast E-commerce Websites</span>{" "}
            in DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we deliver secure and fast e-commerce websites in
            **DIFC**, combining ironclad security with lightning-fast
            performance to ensure customer trust and seamless shopping
            experiences. Boost your business with a store that’s safe and swift.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // E-commerce success imagery
          "https://images.unsplash.com/photo-1616469829581-73993eb86b02?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Mobile e-commerce visuals
          "https://images.unsplash.com/photo-1522542550221-31fd19575a2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Team working
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Launch Securely"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Secure & Speedy Design in DIFC"
        description="We build e-commerce websites prioritizing safety and performance."
        cards={[
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Robust Security",
            description: "Advanced encryption and secure transactions.",
          },
          {
            icon: <FaTachometerAlt color="#ff5464" size={40} />,
            title: "Blazing Speed",
            description: "Optimized for rapid load times.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Conversion Focus",
            description: "Designed to drive sales and trust.",
          },
          {
            icon: <FaLock color="#ff5464" size={40} />,
            title: "Data Protection",
            description: "Safeguard customer and business data.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile Ready",
            description: "Fast and secure on all devices.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Expertise",
            description: "DIFC’s choice for secure e-commerce.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Secure & Fast Design Process"
        description={
          <Description>
            We create secure and fast e-commerce websites with a meticulous
            approach:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Define security and speed goals.</li>
              <li>Design: Craft intuitive, performance-driven layouts.</li>
              <li>Development: Implement secure, optimized code.</li>
              <li>Testing: Verify speed and security standards.</li>
              <li>Launch: Deliver a reliable, high-performing store.</li>
              <li>
                Support: Provide ongoing security updates and optimization.
              </li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1661956602116-aa6865609028?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2564&q=80", // E-commerce success imagery
          "https://images.unsplash.com/photo-1556741533-6e6a62bd8b49?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Mobile e-commerce visuals
          "https://images.unsplash.com/photo-1531973576160-7125cd663d86?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Team working
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Secure & Fast Wins in DIFC"
        description="Our designs have redefined e-commerce reliability."
        cards={[
          {
            icon: <FaTachometerAlt color="#ff5464" size={40} />,
            title: "Speed Surge",
            description: "Reduced load times by 50% for a retailer.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Security Success",
            description: "Zero breaches with enhanced protocols.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Trust",
            description: "97% satisfaction for secure platforms.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Secure Speed?</Subheading>}
        heading="Secure & Fast E-commerce in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset for secure and fast e-commerce website
            design in DIFC. Get a high-performing, protected store that
            customers love—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1559526324-4b87b5e36e44?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Team celebrating
          "https://images.unsplash.com/photo-1621274147744-cfb5032c9d77?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Mobile e-commerce visuals
          "https://images.unsplash.com/photo-1633876841157-78c12e53f35a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // E-commerce success imagery
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
